import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { IoSunny, IoMoon } from 'react-icons/io5';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      type="button"
      className={`swap-arrow-3d relative w-9 h-9 sm:w-10 sm:h-10 shrink-0 flex items-center justify-center ${className}`}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === 'dark' ? (
        <IoSunny className="w-[18px] h-[18px] sm:w-5 sm:h-5" />
      ) : (
        <IoMoon className="w-[18px] h-[18px] sm:w-5 sm:h-5" />
      )}
    </button>
  );
};

export default ThemeToggle;
